import { InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import CodeIcon from "@mui/icons-material/Code";
import React, { useState } from "react";
import axios from "axios";
import { isStartDateGraterThanEndDate } from "utils/customDateFunctions";
import QueryFilterPanel from "components/CustomQueriesDashboard/ReusableComponents/QueryFilterPanel/QueryFilterPanel";
import { grey } from "@mui/material/colors";

const fieldLabelSx = {
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	color: grey[700],
	fontSize: "0.75rem",
	fontWeight: 600,
	letterSpacing: "0.02em",
	textTransform: "uppercase",
};

const fieldSx = {
	width: "100%",
	"& .MuiOutlinedInput-root": {
		minHeight: 40,
		borderRadius: 1.5,
		bgcolor: "grey.50",
		"&:hover": { bgcolor: "common.white" },
		"&.Mui-focused": {
			bgcolor: "common.white",
			boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.12)",
		},
	},
};

const PlanningSaleQuery = () => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [department, setDepartment] = useState("");
	const [division, setDivision] = useState("SELECT");
	const [brand, setBrand] = useState("SELECT");
	const [subCategory, setSubCategory] = useState("");

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoading(true);
		if ((startDate === "" && endDate !== "") || (startDate !== "" && endDate === "")) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "please enter both startdate and end date",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}
		if (isStartDateGraterThanEndDate(startDate, endDate)) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "start date should be less than end date",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}
		try {
			await axios
				.get(
					`/api/custom_queries/planning-sale-query?start_date=${startDate}&end_date=${endDate}&department=${department}&division=${division}&brand=${brand}&subcategory=${subCategory}`
				)
				.then((res) => {
					if (res.status === 200) {
						setLoading(false);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: "file saved successfully in data hub",
							severity: "success",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
					} else if (res.status === 204) {
						setLoading(false);
						setSnackBarOpen(true);
						setSnackBar({
							...snackBar,
							message: res.statusText,
							severity: "error",
							anchorOrigin: { horizontal: "center", vertical: "top" },
						});
					}
				});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "failed to run query",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};

	return (
		<QueryFilterPanel
			onSubmit={handleRunQueryClick}
			loading={loading}
			submitLabel="Run"
			submitIcon={<CodeIcon />}
			hint="Set filters and run to save the planning sale file to Data Hub.">
			<Stack spacing={0.5} sx={{ minWidth: 0 }}>
				<InputLabel sx={fieldLabelSx}>Start Date</InputLabel>
				<TextField
					size="small"
					type="date"
					value={startDate}
					onChange={(e) => setStartDate(e.target.value)}
					sx={fieldSx}
				/>
			</Stack>
			<Stack spacing={0.5} sx={{ minWidth: 0 }}>
				<InputLabel sx={fieldLabelSx}>End Date</InputLabel>
				<TextField
					size="small"
					type="date"
					value={endDate}
					onChange={(e) => setEndDate(e.target.value)}
					sx={fieldSx}
				/>
			</Stack>
			<Stack spacing={0.5} sx={{ minWidth: 0 }}>
				<InputLabel sx={fieldLabelSx}>Department</InputLabel>
				<TextField
					size="small"
					type="text"
					value={department}
					placeholder="Enter Department"
					onChange={(e) => setDepartment(e.target.value.toUpperCase())}
					sx={fieldSx}
				/>
			</Stack>
			<Stack spacing={0.5} sx={{ minWidth: 0 }}>
				<InputLabel sx={fieldLabelSx}>Subcategory</InputLabel>
				<TextField
					size="small"
					type="text"
					value={subCategory}
					placeholder="Enter Subcategory"
					onChange={(e) => setSubCategory(e.target.value.toUpperCase())}
					sx={fieldSx}
				/>
			</Stack>
			<Stack spacing={0.5} sx={{ minWidth: 0 }}>
				<InputLabel sx={fieldLabelSx}>Division</InputLabel>
				<Select
					value={division}
					onChange={(e) => setDivision(e.target.value)}
					size="small"
					sx={fieldSx}
					MenuProps={{
						PaperProps: { sx: { maxHeight: 280, borderRadius: 2 } },
					}}>
					<MenuItem value={"SELECT"}>SELECT</MenuItem>
					<MenuItem value={"APPARELS"}>APPARELS</MenuItem>
					<MenuItem value={"FOOT WEAR"}>FOOT WEAR</MenuItem>
					<MenuItem value={"ADDONS"}>ADDONS</MenuItem>
				</Select>
			</Stack>
			<Stack spacing={0.5} sx={{ minWidth: 0 }}>
				<InputLabel sx={fieldLabelSx}>Brand</InputLabel>
				<Select
					value={brand}
					onChange={(e) => setBrand(e.target.value)}
					size="small"
					sx={fieldSx}
					MenuProps={{
						PaperProps: { sx: { maxHeight: 280, borderRadius: 2 } },
					}}>
					<MenuItem value={"SELECT"}>SELECT</MenuItem>
					<MenuItem value={"RARE RABBIT"}>RARE RABBIT</MenuItem>
					<MenuItem value={"RAREISM"}>RAREISM</MenuItem>
				</Select>
			</Stack>
		</QueryFilterPanel>
	);
};

export default PlanningSaleQuery;
